import BlogsAPI from '../Apis/BlogsAPI';
import BlogCard from './BlogCard';
import './BlogHome.scss';
import SearchCards from '../utils/SearchCards';


function BlogsSearchPage() {
    return (<div>
        <SearchCards selected='Help' card={BlogCard} api={BlogsAPI.fetchBlogs} perRow={2} />
    </div>);
}

export default BlogsSearchPage;